export const BUSINESS = [
    { field: "개발사업", field_eng: "Development Business",
      list: [ { kor: "주택/상업/업무시설 개발사업", eng: "Development/Residence/Office Building Retail" },
              { kor: "도심복합단지개발사업", eng: "MXD" },
              { kor: "도시정비사업", eng: "Urban Development" },
              { kor: "민관합동PF사업", eng: "The Third-Sector Project Financing" } ] },
    { field: "PM/마케팅사업", field_eng: "Project Management/Marketing Business",
      list: [ { kor: "개발전략기획", eng: "Strategic Planning" },
              { kor: "시장조사분석", eng: "Market Research" },
              { kor: "마케팅 전략 수립 및 활동", eng: "Establish Marketing Strategy" },
              { kor: "계약자 관리 및 입주지원", eng: "Contractor Management/Occupancy Support" } ] },
    { field: "부동산금융서비스업", field_eng: "Financing Service Business",
        list: [ { kor: "투자자문", eng: "Investment Consulting" },
                { kor: "자산운용", eng: "Property Management" },
                { kor: "자산관리", eng: "Asset Management" },
                { kor: "해외개발사업", eng: "Overseas Business" } ] },
]
